import { hasFeatureInLocalStorage } from '../../../../global/featureFlags';

// ENG-3551: saved views are opt-in per acting organization (`saved_views`) and
// only on the Inbox and redesigned Referral Management pages. Read synchronously
// from the cached flags (the same idiom resolveStickyTeamQuery uses for `teams`):
// flags are cached before authenticated state exists, so the cached value is
// authoritative for a mount. Callers evaluate this ONCE per mount; a 403 from a
// saved-view request is what hides the strip later in the same mount.
export const SAVED_VIEWS_FEATURE = 'saved_views';

export const savedViewsEnabledForPage = (page) => {
  if (page !== 'inbox' && page !== 'referrals') return false;
  if (hasFeatureInLocalStorage(SAVED_VIEWS_FEATURE) !== true) return false;
  if (page === 'referrals' && hasFeatureInLocalStorage('referral_management_redesign') !== true) return false;
  return true;
};
